'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _StepContainer = require('./StepContainer');

var _StepContainer2 = _interopRequireDefault(_StepContainer);

var _RouterActions = require('../actions/RouterActions');

var _specialAndErrorHandlers = require('../constants/specialAndErrorHandlers');

var _specialAndErrorHandlers2 = _interopRequireDefault(_specialAndErrorHandlers);

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _CurrentStepActions = require('../actions/CurrentStepActions');

var _StepsConfigContainer = require('../globals/StepsConfigContainer');

var _StepsConfigContainer2 = _interopRequireDefault(_StepsConfigContainer);

var _getStepOptions = require('../utils/getStepOptions');

var _getStepOptions2 = _interopRequireDefault(_getStepOptions);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _getRequestedStepFromPath = require('../utils/getRequestedStepFromPath');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOG = _Logger2.default.getLogger('SignupFlow');

var _logBrowserHistoryChange = function _logBrowserHistoryChange() {
  var fromStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown-from-step';
  var toStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown-to-step';

  (0, _AnalyticsActions.trackEvent)('browserButton', {
    action: 'clicked browser button',
    fromStep: fromStep,
    toStep: toStep
  });
};

var _logBeforePageUnload = function _logBeforePageUnload() {
  var leavingStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown-leaving-step-key';

  var leaving = leavingStep || 'unknown-leaving-step-key';
  (0, _AnalyticsActions.trackEvent)('leavePage', { action: 'leave page', leavingStep: leaving });
};

var SignupFlow = function (_React$Component) {
  _inherits(SignupFlow, _React$Component);

  function SignupFlow() {
    _classCallCheck(this, SignupFlow);

    return _possibleConstructorReturn(this, (SignupFlow.__proto__ || Object.getPrototypeOf(SignupFlow)).apply(this, arguments));
  }

  _createClass(SignupFlow, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      // In a situation where we hit the index route or
      // someone refreshes the page, we'll send them to the active
      // step (usually the first step).
      var _props = this.props,
          params = _props.params,
          currentStepKey = _props.currentStepKey;

      var requestedStep = params.step;
      var ErrorHandler = _specialAndErrorHandlers2.default.get(params.step);
      var stepOptions = (0, _getStepOptions2.default)(requestedStep);
      var firstStepKey = _StepsConfigContainer2.default.getKeys().first();

      if (!ErrorHandler) {
        if (!requestedStep) {
          // no step in the url
          this.props.goToStep(firstStepKey);
        } else {
          if (requestedStep !== currentStepKey) {
            if (!stepOptions.get('allowsRedirect')) {
              this.props.goToStep(firstStepKey);
            } else {
              this.props.goToStep(requestedStep);
            }
          }
        }
      } else {
        this.props.updateCurrentStep({ key: requestedStep });
      }
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate() {
      var currentStepKey = this.props.currentStepKey;

      var stepKey = currentStepKey;
      var expectedKey = (0, _getRequestedStepFromPath.getRequestedStepFromPath)();
      if (stepKey && stepKey !== expectedKey) {
        var stepOptions = (0, _getStepOptions2.default)(expectedKey);
        var totalSteps = stepOptions.get('totalSteps');
        var number = stepOptions.get('stepNumber');
        this.props.updateCurrentStep({ key: expectedKey, number: number, totalSteps: totalSteps });
        window.onpopstate = function () {
          _logBrowserHistoryChange(stepKey, expectedKey);
        };
      }
      window.onbeforeunload = function () {
        return _logBeforePageUnload(stepKey);
      };
    }
  }, {
    key: 'getStep',
    value: function getStep(stepKey) {
      var ErrorHandler = _specialAndErrorHandlers2.default.get(stepKey);

      if (ErrorHandler) {
        return {
          handler: ErrorHandler,
          props: {}
        };
      }

      var stepsConfigContainer = _StepsConfigContainer2.default.get();
      var step = stepsConfigContainer.get(stepKey);

      if (!step) {
        var _props2 = this.props,
            location = _props2.location,
            params = _props2.params;


        LOG.error('Step not found', {
          extra: {
            expectedKey: (0, _getRequestedStepFromPath.getRequestedStepFromPath)(),
            stepKey: stepKey,
            location: location,
            params: params
          }
        });

        return {
          handler: _specialAndErrorHandlers2.default.get('general-error'),
          props: {}
        };
      }

      return step.toJS();
    }
  }, {
    key: 'renderStep',
    value: function renderStep(stepKey) {
      var _props3 = this.props,
          location = _props3.location,
          params = _props3.params,
          routes = _props3.routes;

      var Step = this.getStep(stepKey);
      var StepProps = Step.props || {};
      var StepHandler = (0, _StepContainer2.default)(Step.handler, StepProps);

      return _react2.default.createElement(StepHandler, {
        key: 'flow-step-handler-' + stepKey,
        stepKey: stepKey,
        location: location,
        params: params,
        routes: routes
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var currentStepKey = this.props.currentStepKey;

      var stepKey = currentStepKey;

      // This should only happen for a split second during a re-route
      if (!stepKey) {
        return null;
      }

      return this.renderStep(stepKey);
    }
  }]);

  return SignupFlow;
}(_react2.default.Component);

SignupFlow.propTypes = {
  location: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  routes: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
  goToStep: _propTypes2.default.func.isRequired,
  updateCurrentStep: _propTypes2.default.func.isRequired,
  currentStepKey: _propTypes2.default.string
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    currentStepKey: state.currentStep.get('key')
  };
};

var mapDispatchToProps = {
  goToStep: _RouterActions.goToStep,
  updateCurrentStep: _CurrentStepActions.updateCurrentStep
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SignupFlow);
module.exports = exports['default'];